import { render } from "./NcProgressBar.vue?vue&type=template&id=9bcb357a&scoped=true"
import script from "./NcProgressBar.vue?vue&type=script&lang=js"
export * from "./NcProgressBar.vue?vue&type=script&lang=js"

import "./NcProgressBar.vue?vue&type=style&index=0&id=9bcb357a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcb357a"]])

export default __exports__